<template>
  <v-container fluid>
    <v-row align="center" class="px-3">
      <v-col cols="6" md="3">
        <date-picker
          v-model="date"
          :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
          :masks="{ input: 'YYYY-MM-DD' }"
          :disabled-dates="{ weekdays: [1, 2, 3, 4, 5, 6, 7] }"
          :available-dates="availableDates"
          :from-page="fromPage"
          @input="onDateChange"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <div style="display: flex; align-items: center;">
              <v-icon>mdi-calendar</v-icon>
              <input
                :value="inputValue"
                :placeholder="$t('container.stuffing-date')"
                v-on="inputEvents"
                readonly
                style="border: groove; padding: 4px 8px;"
              />
            </div>
          </template>
        </date-picker>
      </v-col>
      <v-col cols="6" md="3">
        <v-select
          v-model="alias"
          :label="$t('container.alias')"
          :items="containers.map(c => c.alias)"
          :disabled="!containers.length"
          outlined
          dense
          hide-details
        ></v-select>
      </v-col>
      <v-col class="d-flex justify-end">
        <v-sheet outlined rounded class="px-4 py-2 text-h5" style="min-width: 16rem;">
          {{ $t("container.transport-status") }}:
          <template v-if="selected">{{ selected.transport_status | getText(transport_status_items) | Translate }}</template>
          <template v-else>-</template>
        </v-sheet>
      </v-col>
    </v-row>
    <base-material-card
      icon="mdi-clipboard-text"
      :title="$t('container-box.customer-list')"
      class="px-5 py-3"
    >
      <v-data-table
        :headers="headers"
        :items="selected ? selected.boxes : []"
        :loading="loading"
        :items-per-page="20"
        :footer-props="footerProps"
      >
        <template v-slot:item.end_box="{ item }">
          {{ item.box_amount > 1 ? item.end_box : "" }}
        </template>
        <template v-slot:item.accreditation_number="{ item }">
          <div v-for="data in item.relation" :key="data.id">{{ data.accreditation_number || '-' }}</div>
        </template>
        <template v-slot:item.customs_type="{ item }">
          <div v-for="data in item.relation" :key="data.id">{{ data.customs_type ? getHanText(data.customs_type, "name") : "" }}</div>
        </template>
        <template v-slot:item.commodity_total_amount="{ item }">
          <div v-for="data in item.relation" :key="data.id">{{ data.commodity_amount }}</div>
        </template>
        <template v-slot:item.supplier="{ item }">
          {{ getHanText(item.supplier, "name") }}
        </template>
        <template v-slot:item.customer="{ item }">
          {{ getHanText(item.customer, "name") }}
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
<script>
import BaseTable from "./BaseTable.vue";
import { transport_status_items } from "@/definition.js";
import { DatePicker } from "v-calendar";
export default {
  data: (vm) => ({
    url: "/container/customer_cargo/",
    dates: [],
    date: null,
    containers: [],
    alias: null,
    // 客戶看不到中國 / 台灣海關的細節,3、4 一律顯示「運送中」;員工頁面維持原樣
    transport_status_items: transport_status_items.map((i) =>
      [3, 4].includes(i.value) ? { ...i, text: "運送中" } : i
    ),
    headers: [
      { sortable: false, text: vm.$i18n.t("container.code"), value: "code" },
      { sortable: false, text: vm.$i18n.t("container.box_str"), value: "start_box", width: "1%" },
      { sortable: false, text: vm.$i18n.t("container.number_str"), value: "end_box", width: "1%" },
      { sortable: false, text: vm.$i18n.t("commodity.name"), value: "accreditation_number" },
      { sortable: false, text: vm.$i18n.t("commodity.customs-type"), value: "customs_type" },
      { sortable: false, text: vm.$i18n.t("container.commodity_per_box"), value: "commodity_total_amount", width: "6%" },
      { sortable: false, text: vm.$i18n.t("container.box_amount"), value: "box_amount", width: "6%" },
      { sortable: false, text: vm.$i18n.t("container.cubic_feet"), value: "cubic_feet" },
      // 供應商頁:供應商欄都是自己所以不顯示;改顯示客戶,一個櫃可能有多個客戶的貨
      vm.supplierView
        ? { sortable: false, text: vm.$i18n.t("customer.customer"), value: "customer" }
        : { sortable: false, text: vm.$i18n.t("supplier.supplier"), value: "supplier" },
    ],
  }),
  props: {
    supplierView: { type: Boolean, default: false },
  },
  mixins: [BaseTable],
  components: { DatePicker },
  computed: {
    selected() {
      return this.containers.find((c) => c.alias === this.alias) || null;
    },
    // 先全部停用(disabled-dates)再用 available-dates 開放;只給 available-dates 時,空清單會變成全部可選
    // 用本地時區建 Date,避免字串被當 UTC 解析而差一天
    availableDates() {
      return this.dates.map((d) => new Date(d + "T00:00:00"));
    },
    fromPage() {
      const last = this.dates[this.dates.length - 1];
      return last ? { year: +last.slice(0, 4), month: +last.slice(5, 7) } : null;
    },
  },
  methods: {
    onDateChange() {
      if (!this.date) return;
      this.alias = null;
      this.containers = [];
      this.getApi(this.url + "?date=" + this.date, (data) => {
        this.containers = data.containers;
        if (this.containers.length === 1) this.alias = this.containers[0].alias;
      }, true);
    },
  },
  mounted() {
    this.getApi(this.url, (data) => {
      this.dates = data.dates;
    }, true);
  },
};
</script>
